import React from 'react';
import NavBar from '../components/navbar';
import { Grid, Paper, Typography } from '@material-ui/core';
import OverviewCard from '../components/overviewcard';
import index from '../data/index';
import '../styles/klassenoverview.css';

const titleClass = "klassenoverview title";
const errorClass = "klassenoverview error";

class KlassenOverview extends React.Component {

    render() {
        const kl = this.props.klasse;
        if (!Object.keys(index).includes(kl)) {
            setTimeout(() => this.props.history.push('/'), 5000);
            return (
                <>
                    <NavBar />
                    <div className={errorClass}>
                        <Typography variant="h4">
                            An error occured while loading the page!<br />
                            It seems like the class you are looking for cannot be found.<br />
                            If you clicked on a link and landed here, please contact the webmaster.
                        </Typography>
                        <Typography variant="h6">You will be redirected in 5 seconds.</Typography>
                    </div>
                </>
            );
        }
        return (
            <>
                <NavBar />
                <Paper>
                    <Typography variant="h2" className={titleClass}>Klasse {kl}</Typography>
                </Paper>
                <Grid
                    container
                    justify="center"
                    alignItems="center"
                >
                    {
                        Object.keys(index[kl]).map((element) => {
                            console.log(index[kl][element]['title'] + "  " + index[kl][element]['description']);
                            let buttons = [];
                            Object.keys(index[kl][element]['types']).forEach((type) => {
                                buttons.push({ 'name': type, 'href': '/klasse/' + kl + '/theme/' + element + '/type/' + type });
                            });
                            return (
                                <Grid container item key={element}>
                                    <OverviewCard title={index[kl][element]['title']} description={index[kl][element]['description']} buttons={buttons} />
                                </Grid>
                            );
                        })}
                </Grid>
            </>
        );
    }
}

export default KlassenOverview;